import { Box, Stack, Typography } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import getLPTheme from "../getLPTheme";
import { useContext } from "react";
import { AuthContext } from "../index";
import App from "./App";
import AuthBySMSForm from "./AuthBySMSForm";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import BIM_LOGO from "../images/bim_logo_100.png";

const theme = createTheme();

export default function Login() {
  const { onLogin } = useContext(AuthContext);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    onLogin({
      email: data.get("email"),
      password: data.get("password"),
    });
  };

  const lightTheme = createTheme(getLPTheme("light"));

  const [button, setButton] = useState({ text: "", loading: false });
  let handleButtonClick = () => {};
  let setButtonClick = (action) => {
    handleButtonClick = action;
  };

  return (
    <App>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          overflowY: "auto",
        }}
      >
        <Stack
          spacing={3}
          sx={{ justifyContent: "center", alignItems: "center" }}
        >
          <Stack
            direction="row"
            sx={{
              p: 2,
              pb: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            spacing={1}
          >
            <Box
              sx={{ height: "20px" }}
              component={"img"}
              alt={"Логотип компании Bim"}
              src={BIM_LOGO}
            />
            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: "300",
                color: "gray",
                alignSelf: "flex-end",
                lineHeight: 1,
              }}
            >
              {`| специалисты`}
            </Typography>
          </Stack>
          <Typography component="h1" variant="h5">
            Войдите в аккаунт
          </Typography>
          <AuthBySMSForm
            setButton={setButton}
            setButtonClick={setButtonClick}
          />
        </Stack>
      </Box>
    </App>
  );
}
